import platform from 'platform-detect'

/** 디바이스 운영 체제를 감지하는 함수 */
export function getDeviceOS(): any {
  if (navigator.userAgent.match(/Android/i)) {
    return 'android'
  } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
    return 'ios'
  } else {
    return null
  }
}

/** 메인 카메라를 선택하는 함수 */
export function selectMainCamera(cameras: MediaDeviceInfo[], cameraDirection: string): MediaDeviceInfo | undefined {
  if (cameraDirection === 'back') {
    let backMainCamera
    if (platform.ios) {
      backMainCamera = cameras[1]
    } else if (platform.android) {
      // select back cameras
      const backCameras = cameras.filter((c) => {
        const lowercaseLabel = c.label.toLowerCase()
        return backCameraKeywords.some((keyword) => {
          return lowercaseLabel.includes(keyword)
        })
      })
      // pick first one after sorting in dictionary order
      backMainCamera = backCameras.sort((a, b) => {
        return a.label.localeCompare(b.label)
      })[0]
    }
    return backMainCamera ?? cameras[1] ?? cameras[0]
  } else if (cameraDirection === 'front') {
    let frontMainCamera
    if (platform.ios) {
      frontMainCamera = cameras[0]
    } else if (platform.android) {
      // select front cameras
      const frontCameras = cameras.filter((c) => {
        const lowercaseLabel = c.label.toLowerCase()
        return frontCameraKeywords.some((keyword) => {
          return lowercaseLabel.includes(keyword)
        })
      })
      // pick first one after sorting in dictionary order
      frontMainCamera = frontCameras.sort((a, b) => {
        return a.label.localeCompare(b.label)
      })[0]
    }
    return frontMainCamera ? frontMainCamera : cameras[0]
  }
}

/** 카메라 방향에 따른 키워드 목록 */
export const backCameraKeywords = [
  '후', // 한국어
  'rear', // 영어
  'back', // 영어
  'rück', // 독일어
  'arrière', // 프랑스어
  'trasera', // 스페인어
  'trás', // 포루투칼어
  'traseira', // 포루투칼어
  'posteriore', // 이탈리아어
  '后面', // 중국어(간체)
  '后置', // 중국어(간체)
  '後面', // 중국어(번체)
  '背面', // 중국어(번체)
  '後置', // 일본어
  '背置', // 일본어
  'задней', // 러시아어
  'الخلفية', // 아랍어
  'arka', // 터키어
  'achter', // 네덜란드어
  'หลัง', // 태국어
  'baksidan', // 스웨덴어
  'bagsiden', // 덴마크어
  'bageste', // 덴마크어
  'sau', // 베트남어
  'bak', // 노르웨이어
  'tylny', // 폴란드어
  'takakamera', // 핀란드어
  'belakang', // 인도네시아어
  'אחורית', // 히브리어
  'πίσω', // 그리스어
  'spate', // 루마니아어
  'hátsó', // 헝가리어
  'zadní', // 체코어
  'darrere', // 카탈로니아어
  'posterior', // 카탈로니아어
  'zadná', // 슬로바키아어
  'vzadu', // 슬로바키아어
  'задня', // 우크라이나어
  'stražnja', // 크로아티아어
  'straga', // 크로아티아
  'बैक', // 힌디어
]
export const frontCameraKeywords = [
  '앞', // 한국어
  'front', // 영어, 덴마크
  'Vordere', // 독일어
  'frontale', // 프랑스어
  'frontal', // 스페인어, 포루투칼어, 카탈로니아어
  'frente', // 포루투칼어
  '前置', // 중국어(간체, 번체)
  '正面', // 중국어(간체, 번체)
  '向前', // 중국어(간체, 번체)
  '前置', // 일본어
  '前方', // 일본어
  '前', // 일본어
  'фронт', // 러시아어
  'передняя', // 러시아어
  'الأمامية', // 아랍어
  'Ön', // 터키어
  'voorkant', // 네덜란드어
  'หน้า', // 태국어
  'framsida', // 스웨덴어
  'foran', // 덴마크어
  'trước', // 베트남어
  'før', // 노르웨이어
  'naprzód', // 폴란드어
  'eteenpäin', // 핀란드어
  'depan', // 인도네시아어
  'קדמית', // 히브리어
  'μπροστινή', // 그리스어
  'față', // 루마니아어
  'elülső', // 헝가리어
  'přední', // 체코어
  'abans', // 카탈로니아어
  'predná', // 슬로바키아어
  'spredu', // 슬로바키아
  'спереду', // 우크라이나어
  'ispred', // 크로아티아어
  'सामने', // 힌디어
]
